import { AvatarService } from '@/services';

export default {
  registerAvatarConsumer({ dispatch }, { agentId, contactId, manualRequest }) {
    if (agentId) {
      dispatch('registerAgentAvatarConsumer', { agentId, manualRequest });
    }
    if (contactId) {
      dispatch('registerContactAvatarConsumer', { contactId, manualRequest });
    }
  },

  registerContactAvatarConsumer({ commit, getters }, { contactId, manualRequest }) {
    commit('registerContactAvatarConsumer', contactId);
    if (getters.getContactAvatar(contactId) === undefined && !manualRequest) {
      commit('setContactAvatar', { contactId, avatar: null });
      AvatarService.getContactAvatar(contactId).then(({ data }) => {
        if (data && data.avatar) {
          commit('setContactAvatar', { contactId, avatar: data.avatar });
        }
      });
    }
  },

  registerAgentAvatarConsumer({ commit, getters }, { agentId, manualRequest }) {
    commit('registerAgentAvatarConsumer', agentId);
    if (getters.getAgentAvatar(agentId) === undefined && !manualRequest) {
      commit('setAgentAvatar', { agentId, avatar: null });
      AvatarService.getAgentAvatar(agentId).then(({ data }) => {
        if (data && data.avatar) {
          commit('setAgentAvatar', { agentId, avatar: data.avatar });
        }
      });
    }
  },

  unregisterAvatarConsumer({ commit }, { agentId, contactId }) {
    if (agentId) {
      commit('unregisterAgentAvatarConsumer', agentId);
    }
    if (contactId) {
      commit('unregisterContactAvatarConsumer', contactId);
    }
  }
};
